import React from "react";
import { Link } from "react-router-dom";

export default function NewChargingAgreementConfirmation() {
  return (
      <div className="container new-charging-agreement__confirmation-container">
          <div className="agreement-confirmed"><h1>Lepingu sõlmimine oli edukas</h1></div>
          <div className="row mr-0 ml-0 mb-5">
              <p> Meil on hea meel, et olete valinud Terminali teenused. Lepingu leiate alati mugavalt iseteenindusest. </p>
          </div>

          <div>
              <Link to='/esileht' className="btn btn-primary btn-lg text-left">
                  Suundu tagasi töölauale
              </Link>
          </div>
      </div>
  )
}